import React from 'react'


const Footer = ({ darkMode }) => {  
  return (
    <div>
        <footer className={`   text-center ${darkMode ? "bg-darkMode" : "bg-lightMode"}`}>
        <div className="text-center p-3">
        Copyright © 2025: 
            <a className="nav-link d-inline mx-2" href="https://www.facebook.com/AhmedD.ElGaml">Ahmed Elgaml</a>

        </div>
        </footer>
    </div>
  )
}

export default Footer